import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from "@angular/core";
import { BreadCrumbTemplate } from "common/breadcrumb/breadcrumb.component";
import { ZoomToolbarService } from "common/zoom/zoom-toolbar/zoom-toolbar.service";
import { BackButton } from "common/breadcrumb/backbutton.component";
import { BehaviorSubject, combineLatest, Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";

export interface HeadlineTranslation {
	translate?: string;
	params?: unknown;
	plainText?: string;
}

@Component({
	selector: "stages-page-header",
	templateUrl: "./page-header.component.html",
	providers: [ZoomToolbarService],
})
export class PageHeaderComponent implements OnChanges, OnDestroy {
	private _destroy$ = new Subject<boolean>();
	showBackButton$ = new BehaviorSubject<boolean>(false);
	showPageHeader$ = new BehaviorSubject<boolean>(false);
	showProcessVersionSwitch$ = new BehaviorSubject<boolean>(false);
	breadCrumbTemplate$ = new BehaviorSubject<BreadCrumbTemplate | undefined>(undefined);
	headline$ = new BehaviorSubject<HeadlineTranslation | undefined>(undefined);
	backButtonWithRouterLink$ = new BehaviorSubject<BackButton | undefined>(undefined);
	backButtonDisabled$ = new BehaviorSubject<boolean>(true);

	showBreadCrumb$ = new BehaviorSubject<boolean>(false);

	@Input()
	headline?: HeadlineTranslation;

	// Please either choose breadCrumb or backButton. Not both.
	@Input()
	breadCrumbTemplate?: BreadCrumbTemplate;

	@Input()
	backButtonWithRouterLink?: BackButton;

	@Input()
	backButtonDisabled: boolean = false;

	@Input()
	isEmbeddedInCard: boolean = false;

	@Input()
	showProcessVersionSwitch: boolean = false;

	@Input()
	disableTypeCheckForPVSwitch = false;

	@Input()
	disablePVSwitch = false;

	@Output() readonly backButtonClicked = new EventEmitter<boolean>();

	constructor() {
		combineLatest([
			this.backButtonDisabled$,
			this.backButtonWithRouterLink$,
			this.breadCrumbTemplate$,
			this.headline$,
			this.showProcessVersionSwitch$,
		])
			.pipe(
				map(
					([backButtonDisabled, backButtonWithRouterLink, breadCrumbTemplate, headline, showProcessVersionSwitch]) => {
						this.showPageHeader$.next(
							headline !== undefined ||
								breadCrumbTemplate !== undefined ||
								backButtonWithRouterLink !== undefined ||
								showProcessVersionSwitch,
						);
						this.showBreadCrumb$.next(
							breadCrumbTemplate !== undefined && (backButtonWithRouterLink === undefined || backButtonDisabled),
						);
						this.showBackButton$.next(
							breadCrumbTemplate === undefined && (backButtonWithRouterLink !== undefined || !backButtonDisabled),
						);
					},
				),
				takeUntil(this._destroy$),
			)
			.subscribe();
	}

	ngOnChanges(_changes: SimpleChanges): void {
		this.breadCrumbTemplate$.next(this.breadCrumbTemplate);
		this.backButtonWithRouterLink$.next(this.backButtonWithRouterLink);
		this.backButtonDisabled$.next(this.backButtonDisabled);
		this.headline$.next(this.headline);
		this.showProcessVersionSwitch$.next(this.showProcessVersionSwitch);
	}

	ngOnDestroy(): void {
		this._destroy$.next(true);
		this._destroy$.complete();
	}
}
